<div class="colab-manager-content-component colab-import fade-in-animation">

    <div class="row" style="margin: 0;">
      <div class="col-md-12 col-sm-12">

        <h1 class="no-margin">{{ 'COMPANY.MANAGER.BLOCK.SECTION_TITLE' | translate }}</h1>

        <p class="text-wrp">
          {{ 'COMPANY.MANAGER.BLOCK.DESCRIPTION_TEXT1' | translate }}
            <br />{{ 'COMPANY.MANAGER.BLOCK.DESCRIPTION_TEXT2' | translate }}</p>

        <p>
          <a href="https://s3.amazonaws.com/colaboradores-live/arquivos-modelo/modelo_bloquear_cpfs_allya_v1-0-0.xlsx">Bloquear por CPFs</a>
          <a href="https://s3.amazonaws.com/colaboradores-live/arquivos-modelo/modelo_bloquear_emails_allya_v1-0-0.xlsx" style="margin-left: 10px">Bloquear por Emails</a>
          <a href="https://s3.amazonaws.com/colaboradores-live/arquivos-modelo/modelo_bloquear_matricula_allya_v1-0-0.xlsx" style="margin-left: 10px">Bloquear por Matrículas</a>
        </p>
        <ul>
          <li>{{ 'COMPANY.MANAGER.BLOCK.TIP1' | translate }}</li>
          <li>{{ 'COMPANY.MANAGER.BLOCK.TIP2' | translate }}</li>
          <li>{{ 'COMPANY.MANAGER.BLOCK.TIP3' | translate }}</li>
        </ul>
        <ng-core-bulk-block
          [title]="'Lista de colaboradores'"
          [subtitle]="'Tamanho Máx.: 5000 linhas.'">
        </ng-core-bulk-block>

      </div>

    </div>

</div>
